export default __webpack_public_path__ + "static/media/boschsans_regular.1918930b.woff2";